import styled from '@emotion/styled';
import {mixinFlexboxColumn, mixinFlexboxRow} from 'webapp-lib/styling';

export const CasusSearchFilterRow = styled.div`
  ${mixinFlexboxRow};
  gap: var(--gutter);
`;

export const CasusSearchFilterColumn = styled.div`
  ${mixinFlexboxColumn};
  gap: var(--gutter-small);
`;
